import UserActions from "../actions/UserActions";

const initalState = {
  isLoggedin: false,
  user: null,
  token: "",
  initialChecked: false,

  signup: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  login: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  initialLogin: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  updateProfile: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  updatePassword: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  uploadImage: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  deleteAccount: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  removeImage: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
};

const userReducer = (state = initalState, action) => {
  switch (action.type) {
    /*===========
    SINGUP
    =============*/
    case UserActions.SIGNUP:
      return {
        ...state,
        signup: {
          ...initalState.signup,
          isLoading: true,
        },
      };
    case UserActions.SIGNUP_SUCCESS:
      return {
        ...state,
        signup: initalState.signup,
        isLoggedin: true,
        user: action.payload.user,
        token: action.payload.token,
      };

    case UserActions.SIGNUP_FAILURE:
      return {
        ...state,
        signup: {
          ...initalState.signup,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    LOGIN
    =============*/
    case UserActions.LOGIN:
      return {
        ...state,
        login: {
          ...initalState.login,
          isLoading: true,
        },
      };
    case UserActions.LOGIN_SUCCESS:
      return {
        ...state,
        login: initalState.login,
        isLoggedin: true,
        user: action.payload.user,
        token: action.payload.token,
      };

    case UserActions.LOGIN_FAILURE:
      return {
        ...state,
        login: {
          ...initalState.login,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    INITIAL_LOGIN
    =============*/
    case UserActions.INITIAL_LOGIN_NO_TOKEN:
      return {
        ...state,
        initialChecked: true,
      };
    case UserActions.INITIAL_LOGIN:
      return {
        ...state,
        initialLogin: {
          ...initalState.initialLogin,
          isLoading: true,
        },
      };
    case UserActions.INITIAL_LOGIN_SUCCESS:
      return {
        ...state,
        initialLogin: initalState.initialLogin,
        isLoggedin: true,
        user: action.payload.user,
        token: action.payload.token,
        initialChecked: true,
      };
    case UserActions.INITIAL_LOGIN_FAILURE:
      return {
        ...state,
        initialLogin: {
          ...initalState.initialLogin,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
        initialChecked: true,
      };

    case UserActions.LOGOUT:
      return {
        ...state,
        isLoggedin: false,
        user: null,
        token: "",
      };

    /*===========
    UPDATE_PROFILE
    =============*/
    case UserActions.UPDATE_PROFILE:
      return {
        ...state,
        updateProfile: {
          ...initalState.updateProfile,
          isLoading: true,
        },
      };

    case UserActions.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        updateProfile: initalState.updateProfile,
        user: {
          ...state.user,
          ...action.payload.user,
        },
      };

    case UserActions.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        updateProfile: {
          ...initalState.updateProfile,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    UPDATE_PASSWORD
    =============*/
    case UserActions.UPDATE_PASSWORD:
      return {
        ...state,
        updatePassword: {
          ...initalState.updatePassword,
          isLoading: true,
        },
      };

    case UserActions.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePassword: initalState.updatePassword,
      };

    case UserActions.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        updatePassword: {
          ...initalState.updatePassword,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    UPLOAD_IMAGE
    =============*/
    case UserActions.UPLOAD_IMAGE:
      return {
        ...state,
        uploadImage: {
          ...initalState.uploadImage,
          isLoading: true,
        },
      };

    case UserActions.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        uploadImage: initalState.uploadImage,
        user: {
          ...state.user,
          imageURL: action.payload.imageURL,
        },
      };

    case UserActions.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        uploadImage: {
          ...initalState.uploadImage,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    DELETE_ACCOUNT
    =============*/
    case UserActions.DELETE_ACCOUNT:
      return {
        ...state,
        deleteAccount: {
          ...initalState.deleteAccount,
          isLoading: true,
        },
      };

    case UserActions.DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccount: {
          ...initalState.deleteAccount,
        },
      };

    case UserActions.DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteAccount: {
          ...initalState.deleteAccount,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    REMOVE_IMAGE
    =============*/
    case UserActions.REMOVE_IMAGE:
      return {
        ...state,
        removeImage: {
          ...initalState.removeImage,
          isLoading: true,
        },
      };

    case UserActions.REMOVE_IMAGE_SUCCESS:
      return {
        ...state,
        removeImage: {
          ...initalState.removeImage,
        },
        user: {
          ...state.user,
          imageURL: action.payload.newImageURL,
        },
      };

    case UserActions.REMOVE_IMAGE_FAILURE:
      return {
        ...state,
        removeImage: {
          ...initalState.removeImage,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };
    default:
      return state;
  }
};

export default userReducer;
